import EditField from './EditField';

export default class IndustryField extends EditField {
  constructor(key, label = '', options = {}) {
    super(key, label, options);
  }

  getValue(data) {
    const code = super.getValue(data);
    return code;
  }
}
